import { useTranslation } from 'react-i18next'
import styled from 'styled-components'
import React from 'react'
import { getUserLanguage } from 'Lib'
import { mapScientificBenefitChartImage } from 'Lib/ImageUtils'

const ChartContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.mediumSmall};
`

const Disclaimer = styled.p`
  font-size: ${({ theme }) => theme.fontSizes.xsmall};
  color: ${({ theme }) => theme.colors.grey400};
  line-height: 140%;
  margin: 0;
`

const ScientificChart: React.FC = () => {
  const { t } = useTranslation()
  const lang = getUserLanguage()
  const ScientificGraph = mapScientificBenefitChartImage(lang)

  return (
    <ChartContainer>
      <ScientificGraph />
      <Disclaimer>{t('benefits.scientific.disclaimer')}</Disclaimer>
    </ChartContainer>
  )
}

export default ScientificChart
